import { hasTestResults, findStringStatusId } from "helpers/RequestTestsHelper";

/** Tiny child-helpers inside the parent helper:
 * Could be chained then to easily combine
 * With other custom methods
 */
const fillBasicFields = request => [
  {
    title: "Product Description Approved",
    finished: request.hasUsersManualApproved
  },
  {
    title: "License Agreement Accepted",
    finished: !request.isSaved
  },
  {
    title: "FCC ID Verified",
    finished: request.model.fccidverified
  },
  {
    title: "Test Results Approved",
    finished: request.hasTestReportsApproved
  }
];

const fillBasicECOs = request => [
  {
    title: "Test Results Approved",
    finished: request.hasTestReportsApproved
  },
  {
    title: "Parent Device Certified",
    finished: request.hasParentApproved
  }
];

const addPayment = request => {
  if (!request.hasBilling) return [];

  return [
    {
      title: "Certification Fee Payment Received",
      finished: request.isPaid
    }
  ];
};

const addHwSw = request => {
  const testStatusId = findStringStatusId(request.testStatus);

  // should be added only if test results already entered by lab
  if (hasTestResults(testStatusId)) {
    const { hwversion, swversion, dpswversion } = request._requestOriginal;
    const dpSwValid = request.isCBSDDPdevice ? dpswversion : true;
    const titleTail = request.isCBSDDPdevice ? "/DP SW" : "";

    return [
      {
        title: `HW/SW${titleTail} Versions Provided`,
        finished: hwversion && swversion && dpSwValid
      }
    ];
  }

  return [];
};

const checklist = {
  checkList: [],
  request: undefined,
  initialize: function(reqData) {
    this.request = reqData;

    return this;
  },
  fillBasicInitials: function() {
    this.checkList = fillBasicFields(this.request);

    return this;
  },
  fillBasicECOs: function() {
    this.checkList = fillBasicECOs(this.request);

    return this;
  },
  addPayment: function() {
    const withPayment = addPayment(this.request);

    this.checkList = [...this.checkList, ...withPayment];

    return this;
  },
  addHwSw: function() {
    const withHwSw = addHwSw(this.request);

    this.checkList = [...this.checkList, ...withHwSw];

    return this;
  },
  getChecklist: function() {
    return this.checkList;
  }
};

export const getInitialChecklist = request =>
  checklist
    .initialize(request)
    .fillBasicInitials()
    .addPayment()
    .addHwSw()
    .getChecklist();

export const getEcoChecklist = request =>
  checklist
    .initialize(request)
    .fillBasicECOs()
    .addPayment()
    .getChecklist();

export const getChecklist = request => {
  if (!request) return null;
  if (request.isInitial) return getInitialChecklist(request);
  if (request.isEco) return getEcoChecklist(request);
  return null;
};



// WEBPACK FOOTER //
// ./src/helpers/ChecklistHelper.js